<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">

        <v-card elevation="0" width="650px" class="py-2" style="padding: 20px; height: fit-content;border-radius: 12px">
            <v-avatar color="#FFF3EE" size="58">
                <svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="none" stroke="green" stroke-width="2" d="m2.13,10.7 4.87,4.87 11.3-11.3" />
                </svg>
            </v-avatar>
            <v-card-title>
                <span class="title">
                    {{ $t('purchaseOrder.delivery.sendForDeliverytitle', { itm: itemLineTitle }) }}
                </span></v-card-title>
            <v-card-text>
                {{ $t('purchaseOrder.delivery.ConfirmReadyForDelivery', { itm: itemLineTitle }) }}
            </v-card-text>
            <v-card-title class="text-left">
                {{ $t("purchaseOrder.delivery.ItemLocation") }}
                <span class="red">*</span>
            </v-card-title>
            <v-autocomplete id="Location" name="LocationName" variant="outlined" v-model="IdLocation"
                persistent-placeholder :placeholder="$t('placeholder.select', {
                    itm: $t('purchaseOrder.delivery.ItemLocation'),
                })
                    " :items="Locations" item-title="locationName" item-value="locationId" hide-details>
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" variant="text">
                        {{ item.locationName }}
                    </v-list-item>
                </template>
            </v-autocomplete>
            <span class="warningHint" id="WarningMsgReference">
                {{ msg.LocationName }}
            </span>

            <card-actions :yes="sendForDelivery" :noFun="atClose" :loader="loader" :yesDisable="loader" width="300px"
                :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>
</template>

<script>
import {
    getAllSupplierLocations
} from "@/api/index";
import cardActions from "@/genericComponent/cardActions.vue";
export default {
    components: { cardActions },
    created() {
        getAllSupplierLocations().then((response) => {
            this.Locations = response.data;
        });
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true
        },
        item: {
            type: String,
            required: true
        },
        loader: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            Locations: [],
            IdLocation: null,
            msg: [],
            itemLineTitle: null,
        }
    },
    methods: {
        atClose() {
            this.$emit("update:modelValue", false);
            this.$emit("closeDialog");
        },
        sendForDelivery() {
            this.$emit("deliverySubmitted");
        }
    },
    watch: {
        IdLocation(newVal) {
            this.$emit("selectedLocation", newVal);
        },
        item(newVal) {
            this.itemLineTitle = newVal;
        }
    }
}

</script>

<style>
.v-card-title {
    font-family: inter;
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    color: #0d0849;
    padding-left: 0px !important;
    padding-top: 10px;
    padding-bottom: 0px;
    white-space: normal !important;
}

.v-card-text {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #768da9;
    padding-left: 0px !important;
    padding-top: 5px !important;
    padding-right: 0px !important;
}
</style>